import { aiStyles as e } from "../../theme/theme.mjs";
import "react";
import { css as t, styled as n } from "styled-components";
import { jsx as r } from "react/jsx-runtime";
//#region src/components/Card/Card.tsx
var i = (e, t) => e === "none" ? "0" : e === "xsmall" ? t.spacing(1) : e === "small" ? t.spacing(2) : e === "medium" ? t.spacing(3) : e === "large" ? t.spacing(4) : typeof e == "number" ? t.spacing(e) : e, a = n.div`
    background-color: ${({ theme: e, $glass: t }) => t ? `${e.colors.card}cc` : e.colors.card};
    color: ${({ theme: e }) => e.colors.cardForeground};
    border-radius: ${({ theme: e, $radius: t }) => t ? t in e.radii ? e.radii[t] : t : e.radii.lg};
    padding: ${({ theme: e, $padding: t }) => i(t, e)};
    transition: all ${({ theme: e }) => e.transitions.normal};

    ${({ $bordered: e, theme: n }) => e && t`
            border: 1px solid ${n.colors.border};
        `}

    ${({ $elevation: e, theme: n }) => t`
            box-shadow: ${{
	none: n.shadows.none,
	low: n.shadows.sm,
	medium: n.shadows.md,
	high: n.shadows.lg
}[e]};
        `}

    ${({ $glass: e }) => e && t`
            backdrop-filter: blur(8px);
            -webkit-backdrop-filter: blur(8px);
        `}

    ${({ $interactive: e, theme: n }) => e && t`
            cursor: pointer;
            &:hover {
                box-shadow: ${n.shadows.md};
                transform: translateY(-1px);
            }
            &:active {
                transform: translateY(0);
            }
        `}

    ${({ $ai: n }) => n && t`
            background-color: transparent;
            ${e.border}
        `}
`, o = n.div`
    display: flex;
    flex-direction: column;
    gap: ${({ theme: e }) => e.spacing(1)};
    margin-bottom: ${({ theme: e }) => e.spacing(2)};
`, s = n.h6`
    font-family: ${({ theme: e }) => e.typographyTokens.fontFamily};
    font-size: ${({ theme: e }) => e.typographyTokens.sizes.base};
    font-weight: ${({ theme: e }) => e.typographyTokens.weights.semibold};
    color: ${({ theme: e }) => e.colors.cardForeground};
    margin: 0;
    line-height: ${({ theme: e }) => e.typographyTokens.lineHeights.tight};
`, c = n.p`
    font-family: ${({ theme: e }) => e.typographyTokens.fontFamily};
    font-size: ${({ theme: e }) => e.typographyTokens.sizes.sm};
    color: ${({ theme: e }) => e.colors.mutedForeground};
    margin: 0;
`, l = n.div`
    display: flex;
    flex-direction: column;
`, u = n.div`
    display: flex;
    align-items: center;
    gap: ${({ theme: e }) => e.spacing(2)};
    margin-top: ${({ theme: e }) => e.spacing(2)};
    padding-top: ${({ theme: e }) => e.spacing(2)};
    border-top: 1px solid ${({ theme: e }) => e.colors.border};
`, d = ({ children: e, className: t, style: n, id: i, padding: o = "medium", radius: s, elevation: c = "low", bordered: l = !0, glass: u = !1, onClick: d, interactive: f, ai: p = !1 }) => /* @__PURE__ */ r(a, {
	className: t,
	style: n,
	id: i,
	$padding: o,
	$radius: s,
	$elevation: c,
	$bordered: l,
	$glass: u,
	$interactive: f ?? !!d,
	$ai: p,
	onClick: d,
	children: e
});
//#endregion
export { d as Card, l as CardContent, c as CardDescription, u as CardFooter, o as CardHeader, s as CardTitle };
